module.exports = __webpack_public_path__ + "static/media/1-2.281e7c59.png";